import React, { useRef, useEffect } from "react"
import mapboxgl from "mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css"

// Css import
import "./styles/heatmapSidebar.css"

mapboxgl.workerClass =
  // eslint-disable-next-line import/no-webpack-loader-syntax
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default

const MAPBOX_TOKEN =
  "pk.eyJ1IjoiYmFsamVldHJlYWN0IiwiYSI6ImNreW54ZmI2ZjNieGUybnFwNnd1aXRudTEifQ.a0Yo3o" +
  "2Cy1mID1653pidRA"

const MarketPriceHexagonMap = () => {
  const mapContainer = useRef(null)
  const map = useRef(null)

  useEffect(async () => {
    mapboxgl.accessToken = MAPBOX_TOKEN

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      zoom: 6,
      // center: [-74.331279, 40.921665],
      center: [-82.728026, 29.125416],
      style: "mapbox://styles/mapbox/dark-v10"
    })
  }, [])

  return (
    <div className="hexagon-grid">
      <div className="sidebar-hexagon">
        <div className="colored-part">
          <h2>
            <a href="/heatmap">
              <i className="fa-solid fa-arrow-left-long"></i>
            </a>
            &nbsp; Market Price
          </h2>
        </div>
        {/*HExagon Menus  */}
        <div className="hex-menus">
          <a href="#" className=" hex-menu full">
            <h6>Market Price</h6>
            <p>100,000</p>
            <div className="text-right">
              <i className="fa-solid fa-angle-right"></i>
            </div>
          </a>

          <a href="#" className="hex-menu">
            <h6>Market Cap</h6>
            <p>100,000</p>
            <div className="text-right">
              <i className="fa-solid fa-angle-right"></i>
            </div>
          </a>
          <a href="#" className="hex-menu">
            <h6>Circulating Supply</h6>
            <p>120 Million Ncash</p>
            <div className="text-right">
              <i className="fa-solid fa-angle-right"></i>
            </div>
          </a>
          <a href="#" className="hex-menu full">
            <h6>Max Supply</h6>
            <p>100,000</p>
            <div className="text-right">
              <i className="fa-solid fa-angle-right"></i>
            </div>
          </a>
        </div>
      </div>
      <div ref={mapContainer} className="map-container"></div>
    </div>
  )
}

export default MarketPriceHexagonMap

const Popup = ({ values }) => {
  return (
    <>
      <p style={{ fontSize: 18, color: "black" }}>Hexagon Details: </p>
      <b>Type:</b>&nbsp; {values.type}
      <br />
      <b>No. of points:</b>&nbsp; {JSON.parse(values.pointsIndex).length}
      <br />
      <b>Center:</b>&nbsp;
      {values.center.geometry.coordinates.map((point, i) => (
        <React.Fragment key={i}>{point.toPrecision(6)}</React.Fragment>
      ))}
      <br />
      <b>Description:</b>&nbsp;
      {values.place ? values.place.place_name : "Not found"}
      <br />
      {values.type === "available" ? (
        <button
          className="gradient-box"
          style={{ margin: "auto", border: "none", color: "white" }}
          onClick={() => {
            console.log("Hello")
          }}>
          Register
        </button>
      ) : null}
    </>
  )
}
